import { render, staticRenderFns } from "./IntegrationButton.vue?vue&type=template&id=16f5a274"
import script from "./IntegrationButton.vue?vue&type=script&lang=js"
export * from "./IntegrationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports